import {
  clearMutationsByKey,
  useCampaignStore,
} from '@lidea/shared/data-access/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { plotsApi } from './../../apis/plots-api';
import { plotKeys } from './../../keys/plot-keys';
import { patchPlotCachesAfterReset } from './patch-plot-after-reset';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UseResetAnalysisProps {
  plotId: number;
}

export function useResetAnalysis(props: UseResetAnalysisProps) {
  const queryClient = useQueryClient();
  const campaignId = useCampaignStore((s) => s.campaignId);
  const mutation = useMutation({
    mutationKey: ['resetAnalysis'],
    mutationFn: plotsApi.resetAnalysis,
    onSuccess: async (_data, variables) => {
      patchPlotCachesAfterReset(queryClient, props.plotId, campaignId);

      const detailKey = plotKeys.detail(props.plotId, campaignId).queryKey;
      const searchesKey = plotKeys.searches(campaignId);

      await queryClient.invalidateQueries({ queryKey: detailKey });
      await queryClient.invalidateQueries({ queryKey: searchesKey });
      await queryClient.invalidateQueries({
        queryKey: ['zoning', variables.analysisId],
      });
      await queryClient.invalidateQueries({
        queryKey: ['measures', variables.analysisId],
      });
      await queryClient.invalidateQueries({
        queryKey: plotKeys.inBound(campaignId),
      });

      await queryClient.refetchQueries({ queryKey: detailKey });
      await queryClient.refetchQueries({ queryKey: searchesKey });
    },
    onSettled: () => {
      clearMutationsByKey(queryClient, ['resetAnalysis']);
    },
  });

  return mutation;
}

export default useResetAnalysis;
